import { render, staticRenderFns } from "./reportCustomComponentRelManageList.vue?vue&type=template&id=65ee37ac&scoped=true"
import script from "./reportCustomComponentRelManageList.vue?vue&type=script&lang=js"
export * from "./reportCustomComponentRelManageList.vue?vue&type=script&lang=js"
import style0 from "./reportCustomComponentRelManageList.vue?vue&type=style&index=0&id=65ee37ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ee37ac",
  null
  
)

export default component.exports